<!--
import { constants } from 'fs';
 * @Autor: fengqi
 * @Date: 2019-10-08 16:37:04
 * @LastEditors: wtt
 * @LastEditTime: 2021-06-11 14:43:15
 -->
<template>
  <div>
    <img src="@imgs/Group3.png" class="Group3">
    <div class="ft38 c11 bold tac l53">领取成功！</div>
    <div class="ft38 c11 bold tac l53 tip">请妥善保管此兑换码</div>

    <div class='code-box tac'>
      <span class="ft34 c11">兑换码:</span>
      <div class='code ft32 cC4 tac'>
        <span class="flex-1" >{{codeKey}}</span>
        <!-- <img src="@imgs/copy_btn.png" class="copy_btn" :data-clipboard-text="codeKey" @click="copy" id="copy"> -->
        <span class="copy_btn" :data-clipboard-text="codeKey" @click="copy" id="copy">复制兑换码</span>
      </div>
    </div>

    <div class='plr30'>
      <div class="ft34 c11 bold lc">兑换流程：</div>
      <!-- <div class="ft28 c3C l40">识别二维码访问【潮级优惠中心】-点击【关注】-点击底部菜单栏【兑换入口】-输入兑换码-点击立即兑换。</div> -->
      <div class="ft28 c3C l40">{{exchangeContext}}</div>

      <!--
        底部的二维码不同环境展示不同
       -->

      <!-- 正式二维码 -->
      <!-- <img src="@imgs/qrCode.png" class="qr_coode" v-if="environment"> -->
      <img :src="qrCode" class="qr_coode">
      <div class="code_text ft26">{{qrCodeContext}}</div>

      <!-- 沙箱二维码 -->
      <!-- <img src="@imgs/qrCode.png" class="qr_coode" v-else> -->
    </div>
  </div>
</template>
<script>
import Clipboard from 'clipboard'
export default {
  name: 'success',
  data () {
    return {
      codeKey: '',
      qrCodeImg: '',
      environment: '',
      exchangeContext: '',
      qrCode: '',
      qrCodeContext: ''
    }
  },
  methods: {

    // 复制兑换码
    copy () {
      var clipboard = new Clipboard('#copy')
      clipboard.on('success', e => {
        this.$Toast({
          message: '复制成功',
          duration: 1500
        })
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        this.$Toast('该浏览器不支持自动复制')
        clipboard.destroy()
      })
    }
  },
  mounted () {
    // 获取当前环境
    this.environment = process.env.NODE_ENV === 'production' ? 'production' : ''

    // 兑换码
    this.codeKey = this.$route.query.codeKey || '123'
    this.exchangeContext = this.$route.query.exchangeContext
    this.qrCode = this.$route.query.qrCode
    this.qrCodeContext = this.$route.query.qrCodeContext
    // 二维码图片
    // this.qrCodeImg = process.env.VUE_APP_QRCODE_IMG
  }
}
</script>
<style scoped>
.Group3{
  width: 225px;
  height: 174px;
  display: block;
  margin: 88px auto 30px;
}
.lc{
  margin-bottom: 30px;
}
.l53{
  line-height: 53px;
}
.l40{
  line-height: 40px;
}
.mb10{
  margin-bottom: 10px;
}
.tip{
  margin: 10px 0;
}
.code{
  display: inline-flex;
  align-items: center;
  min-width: 394px;
  line-height: 80px;
  border: 1px solid #FCE5C3;
  background: #FDF4E8;
  margin-left: 30px;
}
.code-box{
  margin-top: 58px;
  margin-bottom: 75px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -moz-justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
  -webkit-box-pack: center;
  -moz-justify-content: center;
  -webkit-justify-content: center;
  justify-content: center;
}
.qr_coode{
  width: 300px;
  height: 300px;
  display: block;
  margin: 50px auto 30px;
}
.code-box .copy_btn{
  display: inline-block;
  padding: 0 20px;
  /* width: 108px; */
  line-height: 52px;
  color: #994514;
  margin-right: 18px;
  font-size: 24px;
  background-image: linear-gradient(-90deg, #F0CA8F 0%, #EBBE82 100%);
  border-radius: 44px;
}
.flex-1{
  flex: 1;
}

.code_text {
  width: 400px;
  margin: 20px auto 0;
  text-align: center;
}
</style>
<style>
.mint-toast-text{
  font-size: 30px !important;
}
</style>
